import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPhoneNumber, MemberPhone, PhoneAssignmentResult } from 'src/app/models/phone';

import { PhoneEndpoint } from './phone-endpoint.service';


@Injectable({
    providedIn: 'root'
})
export class PhoneService  {

    constructor(
        private phoneEndpoint: PhoneEndpoint
    ) {

     }

    getPhones(tenantId: string, memberId: string): Observable<MemberPhone[]> {
        return this.phoneEndpoint.getPhones(tenantId, memberId);
    }

    addOrUpdate(tenantId: string, model: IPhoneNumber): Observable<MemberPhone> {
        return this.phoneEndpoint.addUpdatePhone(tenantId, model);
    }

    setAsPrimary(tenantId: string, memberId: string, phoneId: number): Observable<MemberPhone[]> {
        return this.phoneEndpoint.setAsPrimary(tenantId, memberId, phoneId);
    }

    delete(tenantId: string, phoneId: number): Observable<boolean> {
        return this.phoneEndpoint.delete(tenantId, phoneId);
    }
    isReassigned(tenantId: string, memberId: string, phoneNumber: string, callingSystem: string): Observable<PhoneAssignmentResult> {
        return this.phoneEndpoint.isPhoneReassigned(tenantId, memberId, phoneNumber, callingSystem);
    }
    saveFRNDOverride(tenantId: string, memberId: string, phoneNumber: string, callingSystem: string,ignoreFRNDResignment: boolean): Observable<any> {
        return this.phoneEndpoint.saveFRNDOverride(tenantId, memberId, phoneNumber, callingSystem, ignoreFRNDResignment);
    }
}


